import { Box, Metadata, useTranslationLang, useTranslations } from "@bsm/component";
import { TUserStudent } from "@bsm/graphql";
import moment from "moment";
import { formatLanguage } from "utils/formatLanguage";
import { formatNationnality } from "utils/formatNationnality";

export const StudentDetailsContent = (props: TStudentDetailsHeader) => {
    const [
        STUDENT_INFORMATION,
        TITLE,
        FAMILY_NAME,
        FIRST_NAME,
        DATE_OF_BIRTH,
        GENDER,
        NUMBER,
        NATIONALITY,
        SPOKEN_LANGUAGE,
        ADDRESS_EMAIL,
        PREFERED_NAME,
        CELEBRITY,
        FAVOURITE_PRIMARY_FOOD,
        FAVOURITE_SECONDARY_FOOD,
        FAVOURITE_COLOUR,
        FAVOURITE_TV_CHARACTER,
        FAVOURITE_BOOK,
        FAVOURITE_GENRE,
        FAVOURITE_SPORT,
        FAVOURITE_ACTIVITY,
        OTHER_INTEREST,
        OTHER_INFORMATIONS
    ] = useTranslations(i18nKeys);

    return (
        <div className="overflow-hidden rounded-3xl shadow bg-white">

            <Box className="p-10">
                <div className="flex items-center gap-3 mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">
                        {STUDENT_INFORMATION}
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
                    <Metadata label={FAMILY_NAME} value={props.user?.lastName} />
                    <Metadata label={FIRST_NAME} value={props.user?.firstName} />
                    <Metadata label={PREFERED_NAME} value={props.user?.preferredName} />
                    <Metadata label={DATE_OF_BIRTH} value={moment(props.user?.dateBirth).format("DD MMM YYYY")} />
                    <Metadata label={GENDER} value={props.user?.sexe} />
                    <Metadata label={NATIONALITY} value={formatNationnality(props.user?.nationality)} />
                    <Metadata label={SPOKEN_LANGUAGE} value={formatLanguage(props.user?.language)} />
                </div>
            </Box>

            <Box className="p-10">
                <div className="flex items-center gap-3 mb-6">
                    <h2 className="text-2xl font-bold text-gray-800">
                        {OTHER_INFORMATIONS}
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4">
                    <Metadata label={CELEBRITY} value={props?.cellebrity} />
                    <Metadata label={FAVOURITE_PRIMARY_FOOD} value={props?.favouritePrimaryFood} />
                    <Metadata label={FAVOURITE_SECONDARY_FOOD} value={props?.favouriteSecondaryFood} />
                    <Metadata label={FAVOURITE_COLOUR} value={props?.favouriteColour} />
                    <Metadata label={FAVOURITE_TV_CHARACTER} value={props?.favouriteTVCharacter} />
                    <Metadata label={FAVOURITE_BOOK} value={props?.favouriteBook} />
                    <Metadata label={FAVOURITE_GENRE} value={props?.favouriteGenre} />
                    <Metadata label={FAVOURITE_SPORT} value={props?.favouriteSport} />
                    <Metadata label={FAVOURITE_ACTIVITY} value={props?.favouriteActivity} />
                    <Metadata label={OTHER_INTEREST} value={props?.OtherInterest} />
                </div>
            </Box>

        </div>
    );
};


const i18nKeys = [
    "BSM.Students.StudentInformation.title",
    "BSM.Student.Details.Page.About.Informations.Section.Title",
    "BSM.Student.Details.Page.About.Informations.Section.FamilyName",
    "BSM.Student.Details.Page.About.Informations.Section.FirstName",
    "BSM.Student.Details.Page.About.Informations.Section.DateOfBirth",
    "BSM.Student.Details.Page.About.Informations.Section.Gender",
    "BSM.Student.Details.Page.About.Informations.Section.Number",
    "BSM.Student.Details.Page.About.Informations.Section.Nationality",
    "BSM.Student.Details.Page.About.Informations.Section.SpokenLanguage",
    "BSM.Student.Details.Page.About.Informations.Section.Email",
    "std_preferred_name",
    "std_preferded_celebrity",
    "std_favourite_primary_food",
    "std_favourite_secondary_food",
    "std_favourite_colour",
    "std_favourite_tv_character",
    "std_favourite_book",
    "std_favourite_genre",
    "std_favourite_sport",
    "std_favourite_activity",
    "std_other_interest",
    "std_other_informations"
];


type TStudentDetailsHeader = Partial<TUserStudent>